import * as RadixDialog from '@radix-ui/react-dialog';
import Spinner from '../../components/spinner';
import { StyledOverlay } from './modal';

const ModalLoader = () => {
  return (
    <RadixDialog.Root open>
      <StyledOverlay />
      <div
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 9999,
        }}
      >
        <Spinner />
      </div>
    </RadixDialog.Root>
  );
};

export default ModalLoader;
